import api from '../config/api';

export const companyService = {
  /**
   * Get company profile
   * @returns {Promise}
   */
  getProfile: async () => {
    const response = await api.get('/company/profile');
    return response.data;
  },

  /**
   * Update company profile
   * @param {Object|FormData} data
   * @returns {Promise}
   */
  updateProfile: async (data) => {
    const config = {};
    if (data instanceof FormData) {
      config.headers = {
        'Content-Type': 'multipart/form-data',
      };
    }
    const response = await api.post('/company/profile', data, config);
    return response.data;
  },

  /**
   * Get company plans
   * @returns {Promise}
   */
  getPlans: async () => {
    const response = await api.get('/company/plans');
    return response.data;
  },

  /**
   * Get plan by ID
   * @param {number} id
   * @returns {Promise}
   */
  getPlan: async (id) => {
    const response = await api.get(`/company/plans/${id}`);
    return response.data;
  },

  /**
   * Subscribe to a plan
   * @param {number} planId
   * @returns {Promise}
   */
  subscribe: async (planId) => {
    const response = await api.post('/company/subscriptions', { plan_id: planId });
    return response.data;
  },

  /**
   * Get subscriptions
   * @param {Object} filters
   * @returns {Promise}
   */
  getSubscriptions: async (filters = {}) => {
    const response = await api.get('/company/subscriptions', { params: filters });
    return response.data;
  },

  /**
   * Cancel subscription
   * @param {number} subscriptionId
   * @returns {Promise}
   */
  cancelSubscription: async (subscriptionId) => {
    const response = await api.post(`/company/subscriptions/${subscriptionId}/cancel`);
    return response.data;
  },

  /**
   * Get company users
   * @param {number} companyId
   * @returns {Promise}
   */
  getUsers: async (companyId) => {
    const response = await api.get(`/company/${companyId}/users`);
    return response.data;
  },

  /**
   * Add user to company
   * @param {number} companyId
   * @param {Object} data
   * @returns {Promise}
   */
  addUser: async (companyId, data) => {
    const response = await api.post(`/company/${companyId}/users`, data);
    return response.data;
  },

  /**
   * Update company user
   * @param {number} companyId
   * @param {number} userId
   * @param {Object} data
   * @returns {Promise}
   */
  updateUser: async (companyId, userId, data) => {
    const response = await api.put(`/company/${companyId}/users/${userId}`, data);
    return response.data;
  },

  /**
   * Remove user from company
   * @param {number} companyId
   * @param {number} userId
   * @returns {Promise}
   */
  removeUser: async (companyId, userId) => {
    const response = await api.delete(`/company/${companyId}/users/${userId}`);
    return response.data;
    },

    /**
     * Get employee profile by ID (for companies viewing applicants)
     * @param {number} employeeId
     * @returns {Promise}
     */
    getEmployeeProfile: async (employeeId) => {
        const response = await api.get(`/company/employees/${employeeId}`);
        return response.data;
    },
};

